import { useQuery, useMutation, useQueryClient } from 'react-query'
import client from './api-client';


async function addContactRequest(request) {
    await client('contactrequest/', { body: request })
}

export function useAddContactRequestMutation(request) {
    const queryClient = useQueryClient();

    return useMutation((request) => addContactRequest(request), );
}